import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bodyAreas, mockupUrl, showcaseFeatures } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-193" data-mp="32kjlbpqg8uwm">
      <div className="mx-auto max-w-5xl text-center" data-id="element-194" data-mp="2xlykpp7ac97n">
        <Eyebrow data-id="element-195" data-mp="2xoba2nfdhluq">The complete 5-volume injury rehabilitation system</Eyebrow>
        <h2 className="font-display text-xl font-black uppercase leading-tight text-navy md:text-3xl" data-id="element-196" data-mp="29x5vscp2z1mj">
          Complete Injury Rehabilitation Bundle
        </h2>
        <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-wide text-steel md:text-sm" data-id="element-197" data-mp="2jv3ll4ml96h9">
          Practical exercises ready for coaches, trainers & active adults
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-2 gap-y-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-198" data-mp="3v9h1nnb3ohmq">
          {bodyAreas.map((area, index) => <li key={area} className="flex items-center gap-2" data-id="element-199" data-mp="24a5vywf7nsla" data-mpi={index}>
              {index > 0 && <span className="text-navy/30" aria-hidden="true" data-id="element-200" data-mp="299a37hikrg8z">
                  •
                </span>}
              {area}
            </li>)}
        </ul>

        <div className="mt-8 grid items-center gap-8 md:grid-cols-2" data-id="element-201" data-mp="2e6ipnuara6g1">
          <OfferLink className="mx-auto w-full max-w-sm" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-202" data-mp="2i9f2139pd6bj">
            <img src={mockupUrl} alt="Complete Injury Rehabilitation Bundle mockup" className="w-full object-contain drop-shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-203" data-mp="1lhl85tedcdoc" />
          </OfferLink>
          <ul className="grid gap-2.5 text-left" data-id="element-204" data-mp="1zcnjiw1ziv8j">
            {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-navy/10 bg-white px-4 py-2.5 text-sm font-semibold text-navy" data-id="element-205" data-mp="12somgdx1ethq">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-206" data-mp="2a44k3rlz598a">
                  <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-207" data-mp="256cha2jsk2pb" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}